module.exports = { "default": require("core-js/library/fn/object/is-extensible"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/is-extensible.js
// module id = g4jZ
// module chunks = 3